import gCard from "@/components/g-card/g-card.vue"
import gForm from "@/components/g-form/g-form.vue"
import gButton from "@/components/g-button/g-button.vue"
import gPdf from "@/components/g-pdf/g-pdf.vue"
import PDFCartaPropostaFinalizado from "@/pages/CartasProposta/GerarCartaProposta/Componentes/PDF/PDFCartaPropostaFinalizado"
import Tools from "@/shared/services/tools";


export default {
    name:'RascunhoCartaProposta',
    components:{
      'g-card': gCard,
      'g-form': gForm,
      'g-button': gButton,
      'g-pdf': gPdf,
      PDFCartaPropostaFinalizado
    },
  
    beforeMount () {
      var cartaId =  this.$route.params.id
      this.CartaPropostaId = cartaId
      // this.PopulaResumaFinal()
  
      const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
      "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  
      var today = new Date();
      var year = today.getDate()+" de "+(monthNames[today.getMonth()]+" de "+ today.getFullYear());
      this.DiaHoje = year;
     },
  
    mounted () {
      var cartaId =  this.$route.params.id
      this.CartaPropostaId = cartaId
      this.PopulaResumaFinal()
  
      const monthNames = ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
      "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"];
  
      var today = new Date();
      var year = today.getDate()+" de "+(monthNames[today.getMonth()]+" de "+ today.getFullYear());
      this.DiaHoje = year;

      this.GetPorcentagensImpostos()
     },
  
    data () {
      return {
        orcamentosInformacoes:[],
        orcamentoDatas:[],
        inputNomeCliente: '',
        infoNomeCliente: '',
        TipoCarta : 0,
        CartaPropostaId: null,
        cartaPropostaArray: {},
        icms: null,
        ipi: null,
        pisCofins: null,
        observacao: null,
        observacaoNegociacao: null,
        formaDePagamento: null,
        executarvisualizacao: 0,
        DiaHoje: null,
        dataInclusao: null,
        pdfAparecer: true,
        renderiza: false,
        inputNomeClientefinal: '',
        codigoCarta: 0,
        valoripi: 0,
        valoricms: 0,
        valorpiscofins: 0,
        podeBaixarPdf: false,
        abrePdf: false,
      }
    },
  
    methods: {
      formataDecimal(valor){
        return Tools.valorDecimalFormatado(valor)
      },
  
      formataMonetario(valor){ 
        return Tools.valorMonetario4Digitos(valor)
      },
      Continuar(){
          this.$router.push('/consultar-cartas-proposta')
      },
  
      incentivos(){
        this.incentivos
        if (this.icms === true){
        this.icms = ("Incluso")
        } else{
        this.icms = ("Diferido")
        }
  
        if (this.ipi === true){
        this.ipi = ("Incluso")
        } else{
        this.ipi = ("Diferido")
        }
  
        if (this.pisCofins === true){
        this.pisCofins = ("Incluso")
        } else{ 
          this.pisCofins = ("Diferido")
        }
      },
  
      observacoes(){
        this.observacoes
        if (this.observacao === null){
        this.observacao = ("Nenhuma Observação")
        } else{
        this.observacao
        }
  
        if (this.observacaoNegociacao === null){
          this.observacaoNegociacao = ("Nenhuma Observação")
          } else{
            this.observacaoNegociacao
          }
      },
  
      novaCarta () {
          this.$router.push('/gerar-carta-proposta-inicio')
      },
  
      gerarPdf() {
        setTimeout(() => {
          this.executarvisualizacao++
        }, "500");
      },
  
      abrirPDF() {
        this.renderiza = false

        setTimeout(() => {        
          this.renderiza = true
        }, 100);

        this.CartaPropostaId = this.$route.params.id
        this.inputNomeClientefinal = this.inputNomeCliente

        this.abrePdf = true
        this.podeBaixarPdf = false
      },
      
      baixarPDF() {
        this.renderiza = false

        setTimeout(() => {        
          this.renderiza = true
        }, 100);

        this.CartaPropostaId = this.$route.params.id
        this.inputNomeClientefinal = this.inputNomeCliente

        this.abrePdf = false
        this.podeBaixarPdf = true
      },
  
      PopulaResumaFinal() {
        this.$isLoading(true)
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `CartaProposta/GetRascunhoCartaProposta/${this.CartaPropostaId}`,
        })
        .then((response) => {
          this.cartaPropostaArray = response.data.data;
          this.TipoCarta = response.data.data.tipoCarta;
          this.dataInclusao = response.data.data.dataInclusaoFormatada;
          this.orcamentosInformacoes = response.data.data.orcamentosInformacoes;
          this.icms = response.data.data.icms;
          this.ipi = response.data.data.ipi;
          this.pisCofins = response.data.data.pisCofins;
          this.observacaoNegociacao = response.data.data.observacaoNegociacao;
          this.formaDePagamento = response.data.data.formaDePagamento;
          this.codigoCarta = response.data.data.codigoCarta;
          this.incentivos()
          this.observacoes()
          
          this.orcamentosInformacoes.forEach((orcamentoInformacao) => {            
            orcamentoInformacao.componentes.forEach(c => {
              c.embalagens = []
              c.embalagemEspecificaFilmeEncolhivel == true ? c.embalagens.push('Filme encolhível - ' + `${c.quantidadeFilmeEncolhivel}`) : ''
              c.embalagemEspecificaCaixaColetiva == true  ? c.embalagens.push('Caixa Coletiva - ' + `${c.quantidadeCaixaColetiva}`) : ''
              c.embalagemEspecificaPalete == true  ? c.embalagens.push('Palete - ' + `${c.quantidadePalete}`) : ''
              c.embalagemEspecificaPapelEmbrulho == true  ? c.embalagens.push('Papel Embrulho - ' + `${c.quantidadePapelEmbrulho}`) : ''
              c.quantidadeOutros == null || 0  ? '' : c.embalagens.push(c.descricaoEmbalagemOutros == null || '' ? 'Outros -' : c.descricaoEmbalagemOutros + `${c.quantidadeOutros}`) 
            })
  
            // i.orcamentoComponentes.forEach((orcamentoComponentes) => {
            //   return orcamentoComponentes
            // })
  
            // i.orcamentoDatas.forEach((orcamentoDatas) => {
            //   return orcamentoDatas
            // })
          })    
        })
        .finally(()=> {
          this.$isLoading(false)
        })
      },
  
      GetPorcentagensImpostos() {
        this.axios({
          method: 'get',
          url: process.env.VUE_APP_WEB_API + `CartaProposta/GetPorcentagensImpostos/${this.CartaPropostaId}`,
        })
          .then((response) => {
            this.valoripi = response.data.data.porcentagemIpi
            this.valoricms = response.data.data.porcentagemIcms
            this.valorpiscofins = response.data.data.porcentagemPisCofins
          })
          .catch(() => {
          });
      }
    },
  
  }